import { Component, Inject, OnInit, Optional, EventEmitter, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { DriverService } from '../../shared/services/driver.service';
import { CacheService } from '@app/shared/services/cache.service';
import { Client } from '@app/shared';

@Component({
  selector: 'app-drivers-block',
  templateUrl: './dashboard-drivers-block.component.html',
  styleUrls: ['./dashboard-drivers-block.component.scss']
})
export class DashboardDriversBlockComponent implements OnInit {
  reason = null;
  reasons = [];
  comment = '';
  in_progress = false;
  err = {
    status: false,
    msg: null
  };

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DashboardDriversBlockComponent>,
    private driver: DriverService,
    private cache: CacheService,
    private client: Client) {
  }

  ngOnInit() {
    this.cache.getValue(this.client.getBlockReasonsUrl, { type: 'driver_block' }).subscribe(res => {
      // console.log(res);
      this.reasons = res;
      this.reason = this.reasons[0] ? this.reasons[0].id : '';
    })
  }

  driverBlock() {
    this.in_progress = true;
    this.driver.driverBlock({
      'id': this.data.id,
      'service': this.data.service,
      'reason_id': this.reason,
      'comment': this.comment
    }).pipe(
      catchError(data => {
        this.in_progress = false;
        return of(data);
      })
    ).subscribe(res => {      
      if (!res.error) {
        this.dialogRef.close('true');
        this.driver.emitBlockUserEvent({id: this.data.id, service_id: this.data.service})
      }
      this.in_progress = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-drivers-block/dashboard-drivers-block.component.ts